module.exports = __webpack_public_path__ + "images/bullet-list.d7f973b60a4925bd6b4be9b441c6a14c.svg";